import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  Alert,
  Spinner,
} from "react-bootstrap";
import Dashboard from "../components/MerchantDashboard";
import { PayPalButton } from "react-paypal-button-v2";
import CustomHelmet from "../components/CustomHelmet";
import axios from "axios";

const url = "https://www.hubsquares.com/php_files/upgradeSub.php/";
const urlListing =
  "https://www.hubsquares.com/php_files/fetchListingOwner.php/";
const UpgradePlan = (props) => {
  const [plan, setPlan] = useState("Standard Plan Monthly");
  const [selectedPlan, setSelectedPlan] = useState(
    "P-6U349967PV603414NL345XGQ"
  );
  const [successPay, setSuccessPay] = useState(false);
  const [spinPay, setSpinPay] = useState(false);
  const [errorValuePay, setErrorValuePay] = useState("");
  useEffect(() => {
    if (plan === "Standard Plan Monthly") {
      setPlan("Standard plan Monthly");
      setSelectedPlan("P-6U349967PV603414NL345XGQ");
    }
    if (plan === "Standard Plan Yearly") {
      setPlan("Standard plan (yearly)");
      setSelectedPlan("P-4VD61776WJ137784JL4CIBUI");
    }
  }, [plan]);

  useEffect(() => {
    const fetchListing = async () => {
      await axios.post(urlListing, { owner: props.user }).then((res) => {
        if (!res.data.listing) props.history.push("/my-listings");
      });
    };
    fetchListing();
  }, [props.user, props.history]);
  async function handlePaypal(data) {
    setSpinPay(true);
    await axios
      .post(url, {
        owner: props.user,
        package: plan,
        subscriptionID: data.subscriptionID,
      })
      .then(({ data }) => {
        setErrorValuePay("You have successfully upgraded your plan.");
        setSuccessPay(true);
        setSpinPay(true);
        props.history.push("/profile");
      });
  }
  return (
    <>
      <CustomHelmet page="Change Plan" />
      <Dashboard user={props.user} page="Change Plan">
        <Container className="mt-3" style={{ minHeight: "60vh" }}>
          <Card>
            <Card.Body>
              <Row>
                <Col md={3}></Col>
                <Col md={6}>
                  <Form.Control
                    value={plan}
                    className="my-3"
                    onChange={(e) => setPlan(e.target.value)}
                    as="select"
                  >
                    <option disabled>Basic Plan</option>
                    <option value="Standard Plan Monthly">
                      Standard Plan Monthly ($2)
                    </option>
                    <option value="Standard Plan Yearly">
                      Standard Plan Yearly ($20)
                    </option>
                  </Form.Control>
                  <PayPalButton
                    options={{
                      vault: true,
                      clientId:
                        "AS5P5-XGs4LmN6u789FGYFjbIdJvB_vIC4F2G1uNUhRZPV6c-EKU0UEri91w7h3EwpIqWDvUIVIOZpk-",
                    }}
                    onError={(err) => {
                      console.log(err);
                    }}
                    createSubscription={(data, actions) => {
                      return actions.subscription.create({
                        plan_id: selectedPlan,
                      });
                    }}
                    onApprove={(data, actions) => {
                      return actions.subscription
                        .get()
                        .then(function (details) {
                          handlePaypal(data);
                        });
                    }}
                  />
                  {spinPay && (
                    <Spinner
                      className="text-red fs-24"
                      animation="border"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  )}
                  {successPay && (
                    <Alert variant="success">{errorValuePay}</Alert>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </Dashboard>
    </>
  );
};
export default UpgradePlan;
